<template lang="pug">
section
    .title-page
        .container
            h2 Appel d'offre
    //.alert.alert-primary.border-0.text-center.rounded-0.m-0(v-if='!isAuth')
    //  | Essayez Tendfox gratuitement pendant 7 jours.
    //  router-link(to='/register', tag='a', class="nav-item", v-if='!isAuth')  Inscrivez-vous
    #printMe.container.pt-5
        div(v-if="appelOffre != null")
            vue-headful(
                :title="`${getMetaTitleInfo} | Tendfox`",
                lang="fr_FR",
                :description="`${getMetaDescriptionInfo}`"
            )
        .mb-2
            a.retour-rechercheAO(@click="$router.push('/listappeloffre')")
                i.fa.fa-arrow-left.mr-2
                span Revenir aux résultats
        // Modal
        .modal.fade(
            tabindex="-1",
            role="dialog",
            aria-labelledby="exampleModalLabel",
            aria-hidden="true"
        )
            .modal-dialog.modal-dialog-centered(role="document")
                .modal-content
                    .modal-header
                        h5.modal-title Formulaire pour retirer le CDC
                        button.close(
                            type="button",
                            data-dismiss="modal",
                            aria-label="Close"
                        )
                            span(aria-hidden="true") ×
                    .modal-body
                        p Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                        | sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut

                    .modal-footer
                        button.btn.btn-secondary(
                            type="button",
                            data-dismiss="modal"
                        ) Annuler
                        button.btn.btn-primary(type="button") Envoyer
        // Modal
        #erreur.modal.fade(
            tabindex="-1",
            role="dialog",
            aria-labelledby="signaler_erreur",
            aria-hidden="true"
        )
            .modal-dialog.modal-dialog-centered(role="document")
                .modal-content
                    .modal-header
                        h5#signaler_erreur.modal-title Formulaire pour retirer le CDC
                        button.close(
                            type="button",
                            data-dismiss="modal",
                            aria-label="Close"
                        )
                            span(aria-hidden="true") ×
                    .modal-body
                        .input-group.mb-3
                            input.form-control(
                                type="text",
                                placeholder="Type d'erreur",
                                aria-label="Info",
                                aria-describedby="tf_share_email"
                            )

                        .input-group.mb-3
                            textarea.form-control(
                                type="text",
                                placeholder="Signaler votre  erreur",
                                aria-label="Info",
                                aria-describedby="tf_share_email"
                            )
                    .modal-footer
                        button.btn.btn-secondary(
                            type="button",
                            data-dismiss="modal"
                        ) Annuler
                        button.btn.btn-primary(type="button") Envoyer
        .row(v-if="appelOffre !== null")
            .col-md-5.col-lg-4.col-xl-3.sidebar_ao
                .card.mb-3.tf_card
                    .card-body
                        h5 Infos Annonceur
                        .sidebar_ao_logo(
                            :class="{ 'p-0': !canViewAppeloffre() }"
                        )
                            img(
                                :src="appelOffre.annonceur.logo",
                                :alt="appelOffre.annonceur.nom",
                                width="100px",
                                v-if="appelOffre.annonceur.logo !== null && canViewAppeloffre()"
                            )
                            img.mw-100(
                                :src="censoredAnnonceur",
                                v-if="!canViewAppeloffre()"
                            )
                            img(
                                :src="defaultImage",
                                v-if="appelOffre.annonceur.logo === null && canViewAppeloffre()",
                                width="100px"
                            )
                        h5.sidebar_ao_title.card-title(
                            v-if="canViewAppeloffre()"
                        ) {{ appelOffre.annonceur.nom }}
                        h5.sidebar_ao_title.card-title(v-else)
                        .total_publication
                            span Total publication :
                            span.text-right {{ appelOffre.annonceur.annonces }}
                        .info_contact_factory
                            //.info_contact_factory-details
                                span.mr-3
                                    .icon
                                        img(:src="phone", alt="", srcset="")
                                span.icon_info
                                    span 213 23 96 59 90
                                    span 213 23 96 55 50
                                    span 213 23 96 58 51
                            //.info_contact_factory-details
                                span.mr-3
                                    .icon
                                        img(:src="fax", alt="", srcset="")
                                span.icon_info
                                    span 213 23 96 51 52
                            .info_contact_factory-details
                                span.mr-3
                                    .icon
                                        img(:src="map", alt="", srcset="")
                                span.icon_info(
                                    v-show="appelOffre.retrait.adresse !== null"
                                )
                                    span {{ appelOffre.retrait.adresse }}
                                span.icon_info(
                                    v-show="appelOffre.retrait.adresse === null"
                                )
                                    span {{ appelOffre.retrait.wilaya.nom }}
                    .card-footer(v-if="canViewAppeloffre()")
                        a.card-link(
                            :href="`/listappeloffre/?annonceur=${appelOffre.annonceur.id}`",
                            @click.prevent="searchAnnonceur()"
                        ) + Voir plus de publications de cet annonceur
                .card.mb-3.tf_card.info-annonce
                    .card-body
                        h5 Infos Annonce
                        ul.list-unstyled
                            li
                                span Statut :
                                span.text-right(
                                    data-toggle="tooltip",
                                    data-placement="top",
                                    :title="getStatutAo(appelOffre.statut)"
                                ) {{ getStatutAo(appelOffre.statut) }}
                            li
                                span Type :
                                span.text-right {{ appelOffre.type === 'national' ? 'National' : 'National & international' }}
                            //li.categories
                                span Catégorie :
                                ul.list-unstyled
                                    li(v-for='cat in appelOffre.secteursActivites') {{cat}}
                            li.categories
                                span Catégories :
                                ul.list-unstyled
                                    li(
                                        v-for="secteur in appelOffre.secteursActivites"
                                    )
                                        a(
                                            :href="`/listappeloffre/?secteur=${secteur.id}`",
                                            style="color: white"
                                        ) {{ secteur.nom }}
                            li
                                span Code :
                                span.text-right(
                                    v-if="canViewAppeloffre()",
                                    data-toggle="tooltip",
                                    data-placement="top",
                                    :title="appelOffre.code"
                                ) {{ appelOffre.code }}
                                span.text-right(
                                    v-if="haveAccessSecteur && !canViewAppeloffre()",
                                    data-toggle="tooltip",
                                    data-placement="top",
                                    title="Réservé aux abonnés"
                                )
                                    a(role="button", @click="goToAction()")
                                        i.text-primary.fa.fa-lock.mr-1(
                                            aria-hidden="true"
                                        )
                                        | {{ erreurAcces }}
                            li
                                span Identifiant :
                                span.text-right {{ appelOffre.id }}
                            li
                                span Date publication:
                                span.text-right {{ getFormatDate(appelOffre.datePublication) }}
                            li
                                span Date d'échéance :
                                span.text-right {{ getFormatDate(appelOffre.dateEcheance) }}
                            li(v-if="appelOffre.wilayas.length > 0")
                                span Wilaya{{ appelOffre.wilayas.length > 1 ? 's' : '' }} :
                                span.text-right
                                    a(
                                        v-for="(wilaya, index) in appelOffre.wilayas",
                                        :href="`/listappeloffre/?wilaya=${wilaya.id}`"
                                    ) {{ index < appelOffre.wilayas.length - 1 ? wilaya.nom + ', ' : wilaya.nom }}
                    .card-footer(
                        v-if="canViewAppeloffre() && HasPublicationRelier && appelOffre.publicationsRelié > 1"
                    )
                        a.card-link(
                            :href="`/listappeloffre/?annonceur=${appelOffre.annonceur.id}&c=${this.appelOffre.code}`",
                            @click.prevent="searchPublicationRelier()",
                            v-if="HasPublicationRelier && appelOffre.publicationsRelié > 1"
                        ) + Voir les publications reliées ({{ appelOffre.publicationsRelié }})
                    .card-body.tf_ao_action
                        hr(
                            v-if="appelOffre.statut === 'avis-appel-offre' && appelOffre.retrait.wilaya.id !== 59 && appelOffre.retrait.prixCDC !== null && appelOffre.retrait.wilaya.id !== null"
                        )
                        h5(
                            v-if="appelOffre.statut === 'avis-appel-offre' && appelOffre.retrait.wilaya.id !== 59 && appelOffre.retrait.prixCDC !== null && appelOffre.retrait.wilaya.id !== null"
                        ) Services
                        el-dialog(
                            title="Retirer le cahier de charge",
                            :visible.sync="dialogFormVisible",
                            width="30%"
                        )
                            .modal-body(
                                v-if="!messageCdc && appelOffre.retrait.demande_en_cours === false && appelOffre.retrait.demande_livré === false"
                            )
                                p Vous êtes sur le point de demander le retrait du cahier des charges (CDC) relatif à l’appel d’offre <span class="text-primary">N° {{ appelOffre.code }} </span> publié par {{ appelOffre.annonceur.nom }}
                                p
                                    | Ci-dessous les détails de l’opération :
                                ul.list-unstyled.flex-column
                                    li <span class='font-weight-bold'>Coût du CDC :</span> <span class='text-primary'> {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'dzd' }).format(appelOffre.retrait.prixCDC) }}</span>
                                    li <span class='font-weight-bold'> Wilaya de retrait :</span> <span class='text-primary'>{{ appelOffre.retrait.wilaya.nom }}</span>
                                    li <span class='font-weight-bold'> Prix estimatif du retrait :</span> <span class='text-primary'>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'dzd' }).format(appelOffre.retrait.wilaya.prixRetrait) }}</span>
                                    li <span class='font-weight-bold'> Délai de livraison :</span> <span class='text-primary'>{{ appelOffre.retrait.wilaya.delaiLivraison }} jours </span>
                                hr(
                                    v-show="appelOffre.statut === \"avis-appel-offre\" && appelOffre.retrait.wilaya.id !== 59 && appelOffre.retrait.prixCDC !== null && appelOffre.retrait.wilaya.id !== null"
                                )
                            .modal-body(v-else)
                                p Votre demande de retrait de cahier de charge est en cours de traitement
                                p Coût total de l’opération : {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'dzd' }).format(getPrice()) }}
                                p Vous serez livré dans approximativement {{ appelOffre.retrait.wilaya.delaiLivraison }} jours
                                hr
                            span.dialog-footer(
                                slot="footer",
                                v-if="!messageCdc || appelOffre.retrait.demande_en_cours === true"
                            )
                                .text-center
                                    .alert.alert-warning.border-0.text-center
                                        | Le montant final sera communiqué avec le service client.
                                    p.mb-3
                                        router-link(
                                            to="/cdc",
                                            tag="a",
                                            target="_blank"
                                        ) Voir mes demandes cahier de charges
                                        br
                                        a(:href="procuration", target="_blank") Télécharger le modèle de procuration ici !
                                button.btn.btn-primary(
                                    type="primary",
                                    @click="addCdc()",
                                    v-if="appelOffre.retrait.demande_en_cours === false && appelOffre.retrait.demande_livré === false && canViewAppeloffre()"
                                ) Commander
                                button.btn.btn-primary(
                                    v-else,
                                    type="primary",
                                    @click="goToAction()"
                                ) Inscription gratuite
                            span.dialog-footer(slot="footer", v-else)
                                .text-center
                                    p.mb-3
                                        a(:href="procuration", target="_blank") Télécharger le modèle de procuration ici !
                        button.btn.btn-primary.btn_cdc.w-100.mb-4(
                            v-if="appelOffre.statut === 'avis-appel-offre' && appelOffre.retrait.wilaya.id !== 59 && appelOffre.retrait.prixCDC !== null && appelOffre.retrait.wilaya.id !== null && compareDate()",
                            data-toggle="modal",
                            data-target="#exampleModal",
                            @click="modalCdc"
                        ) Commander le CDC Associé
                        ul.list-inline.text-center
                            li.list-inline-item
                                a(
                                    v-if="canViewAppeloffre()",
                                    role="button",
                                    title="Imprimer",
                                    @click.prevent="printAo"
                                )
                                    span.tf_sprite.tf_imprimer
                                a(
                                    v-else,
                                    role="button",
                                    title="Imprimer",
                                    @click.prevent="goToAction()"
                                )
                                    span.tf_sprite.tf_imprimer
                            li.list-inline-item
                                a(
                                    v-if="canViewAppeloffre()",
                                    role="button",
                                    title="Télécharger",
                                    @click.prevent="generatePdf"
                                )
                                    span.tf_sprite.tf_telecharger
                                a(
                                    v-else,
                                    role="button",
                                    title="Télécharger",
                                    @click.prevent="goToAction()"
                                )
                                    span.tf_sprite.tf_telecharger
                            li.list-inline-item.tf_sharing(title="Partager")
                                //a(href="#", title="title")
                                social-sharing(
                                    url="http://www.tendfox.com/",
                                    title="TENDFOX est le portail de veille sur les marchés publics et privés",
                                    description="TENDFOX est le portail de veille sur les marchés publics et privés qui s’adresse à tous les types d’entreprises.",
                                    quote="TENDFOX est le portail de veille sur les marchés publics et privés",
                                    hashtags="appeloffre,tendfox",
                                    twitter-user="tendfox",
                                    inline-template=""
                                )
                                    network(network="facebook")
                                        span.tf_sprite.tf_share
                            li.list-inline-item(v-if="isAuth")
                                a(
                                    href="#",
                                    title="Envoyer par e-mail",
                                    @click.prevent="dialogFormEmailVisible = true"
                                )
                                    span.tf_sprite.tf_envoyer
                            li.list-inline-item(v-if="isAuth")
                                a(
                                    href="#",
                                    title="Signaler une erreur",
                                    @click.prevent="dialogFormErreur = true"
                                )
                                    span.tf_sprite.tf_signaler
                            el-dialog(
                                title="Signaler une erreur",
                                :visible.sync="dialogFormErreur",
                                width="35%",
                                v-if="isAuth"
                            )
                                el-form
                                    .modal-body
                                        .input-group.mb-3
                                            select.custom-select.form-control-lg.form-control(
                                                v-model="erreurAo.type",
                                                data-vv-as="type",
                                                data-vv-name="type",
                                                name="type",
                                                v-validate="\"required\"",
                                                :class="{ 'is-invalid': errors.has('type') }"
                                            )
                                                option(
                                                    :value="erreur.id",
                                                    v-for="erreur in erreurList"
                                                ) {{ erreur.text }}
                                            .invalid-feedback(
                                                v-show="errors.has(\"type\")"
                                            ) {{ errors.first('type') }}
                                        .input-group.mb-3
                                            textarea#comment.form-control(
                                                rows="4",
                                                v-model="erreurAo.text"
                                            )
                                span.dialog-footer(slot="footer")
                                    button.btn.btn-primary(
                                        type="primary",
                                        @click="sendErreur()"
                                    ) Envoyer
                            el-dialog(
                                title="Envoyer l'appel d'offre par email",
                                :visible.sync="dialogFormEmailVisible",
                                width="30%"
                            )
                                el-form
                                    .modal-body
                                        p Ce service permet d’envoyer un aperçu du présent appel d’offre à une de vos connaissances;
                                        .input-group.mb-3
                                            input.form-control.form-control-lg(
                                                type="email",
                                                placeholder="Veuillez renseigner l’adresse email",
                                                :data-vv-as="$t('user.email')",
                                                v-model="email",
                                                data-vv-name="email",
                                                v-validate="'required|email'",
                                                name="email",
                                                data-vv-rules="required|email",
                                                :class="{ 'is-invalid': errors.has('email') }"
                                            )
                                            .invalid-feedback(
                                                v-show="errors.first('email')"
                                            ) {{ errors.first('email') }}
                                span.dialog-footer(slot="footer")
                                    button.btn.btn-primary(
                                        type="primary",
                                        @click="sendEmail()"
                                    ) Envoyer
            .col-md-7.col-lg-8.col-xl-9
                .card.tf_card.card-content
                    .card-body
                        img.img-fluid.mx-auto.d-block.mb-3(
                            :src="pubImage",
                            alt="SARL FAST INFORMATIQUE"
                        )
                        h5.tf_card_title
                            span {{ appelOffre.titre }}
                            span
                                button.btn.btn-primary.rounded-0.w-100.text-uppercase.font-weight-bold(
                                    @click.prevent="editAo",
                                    v-if="profilLoaded && profil.services.filter((x) => x.name === 'Edit Appel Offre').length > 0"
                                ) Edit AO
                            span.favoris
                                button.btn.btn-sm(
                                    role="button",
                                    :title="appelOffre.stared.state ? 'Supprimer de mes favoris' : 'Ajouter à mes favoris'",
                                    @click.prevent="addRemoveFavoris",
                                    :class="{ 'btn-primary': appelOffre.stared.state }"
                                )
                                    i.fa.fa-star
                        .alert.alert-warning.border-0.text-center(
                            v-if="appelOffre.statut === 'avis-appel-offre' && appelOffre.retrait.wilaya.id !== 59 && appelOffre.retrait.prixCDC !== null && appelOffre.retrait.wilaya.id !== null && compareDate() == true",
                            data-toggle="modal"
                        )
                            | Saisissez cette opportunité
                            a.nav-item(
                                href="#",
                                v-if="appelOffre.statut === 'avis-appel-offre' && appelOffre.retrait.wilaya.id !== 59 && appelOffre.retrait.prixCDC !== null && appelOffre.retrait.wilaya.id !== null && compareDate()",
                                data-toggle="modal",
                                data-target="#exampleModal",
                                @click="modalCdc"
                            ) commander le cahier des charges associé
                        .card-text
                            .source_action(
                                :class="{ multi: imageSources.length > 0 && appelOffre.documents.length > 0 }"
                            )
                                .source_journal
                                    .source_journal_media(
                                        v-if="imageSources.length > 0 && canViewAppeloffre()"
                                    )
                                        span(
                                            v-for="document in imageSourcesPDF"
                                        )
                                            a(
                                                :href="document.src",
                                                target="_blank"
                                            )
                                                img(
                                                    :src="pdfImage",
                                                    width="auto",
                                                    height="100"
                                                )
                                        viewer(
                                            :images="imageSourcesPNG[0].src",
                                            width="auto",
                                            height="100",
                                            v-if="imageSourcesPNG.length > 0",
                                            style="display: inline"
                                        )
                                            img(
                                                v-for="image in imageSourcesPNG",
                                                :src="image.src",
                                                :key="image.src",
                                                v-if="imageSourcesPNG.length > 0",
                                                width="auto",
                                                height="100",
                                                style="padding-right: 15px"
                                            )
                                    .source_journal_media(
                                        v-if="haveAccessSecteur && !canViewAppeloffre()"
                                    )
                                        span Image source:
                                        a.text-primary.ml-2(
                                            role="button",
                                            @click="goToAction()"
                                        )
                                            i.text-primary.fa.fa-lock.mr-1(
                                                aria-hidden="true"
                                            )
                                            | {{ erreurAcces }}
                                        span(
                                            v-for="document in imageSourcesPDF"
                                        )
                                    .source_journal_title
                                        span Source de parution:
                                        span.source_journal_title_name(
                                            v-if="canViewAppeloffre()"
                                        ) {{ appelOffre.sources.map((source) => source.nom).join(', ') }}
                                        span.source_journal_title_name.ml-2(
                                            v-if="haveAccessSecteur && !canViewAppeloffre()"
                                        )
                                            a.text-primary(
                                                role="button",
                                                @click="goToAction()",
                                                style="text-transform: none"
                                            )
                                                i.text-primary.fa.fa-lock.mr-1(
                                                    aria-hidden="true"
                                                )
                                                | {{ erreurAcces }}
                                .documents_additionels(
                                    v-if="(appelOffre.documents.length > 0) & canViewAppeloffre()",
                                    :class="{ alone: imageSources.length === 0 }"
                                )
                                    .documents_additionels_media
                                        span.dl_content(
                                            v-for="document in appelOffre.documents"
                                        )
                                            a(
                                                :href="document.uri",
                                                target="_blank"
                                            )
                                                //img(:src='pdfImage',width="100", height="100")
                                                span.fa-stack.fa-2x
                                                    i.fa.fa-circle.fa-stack-2x
                                                    i.fa.fa-download.fa-stack-1x.fa-inverse
                                            a(
                                                :href="document.uri",
                                                target="_blank"
                                            ) {{ document.name }}
                            div(
                                :class="{ 'tf_ao-content arabe': isArabe, 'tf_ao-content': !isArabe }"
                            )
                                span(
                                    v-html="getDescription()",
                                    v-if="canViewAppeloffre()"
                                )
                                span(
                                    v-if="!canViewAppeloffre()",
                                    @click="goToAction()"
                                )
                                    img.img-fluid(
                                        v-if="appelOffre.statut === 'attribution-marche'",
                                        :src="aaCensored"
                                    )
                                    img.img-fluid(v-else, :src="aoCensored")
                                //span(v-else)
                                //  .alert.alert-success.text-center(v-show='appelOffre.sources.findIndex((source) => source.nom === "BAOSEM" ) === -1')
                                //    a.text-primary( role="button" @click="goToAction()") Réservé aux abonnés
                            .alert.bg-gray.text-danger(
                                v-show="appelOffre.sources.findIndex((source) => source.nom === \"BAOSEM\" ) === -1"
                            )
                                | La date de remise des offres est donnée à titre indicatif, veuillez confirmer la date réelle auprès de l’annonceur
                        div(v-for="(image, index) in imagesAsBase64")
                            a(:href="image", target="_blank")
                                img(:src="image", width="100px")
</template>
<script>
// import store from './../store/DataStore'
import Vue from 'vue'
import Vuex from 'vuex'
import logo from '@/assets/images/engoaLogo.png'
import phone from '@/assets/images/phone.png'
import fax from '@/assets/images/fax.png'
import map from '@/assets/images/map.png'
import procuration from '@/assets/document/modeleprocuration.pdf'
import vueHeadful from 'vue-headful'
import LightBox from 'vue-image-lightbox'
import {Button, Dialog, FormItem, Input, Loading} from 'element-ui'
import source from '@/assets/images/news.jpg'
import moment from 'moment'
import defaultImage from '@/assets/images/Entreprise2-320x320.png'
import censoredAnnonceur from '@/assets/images/Annonceur-flou.jpg'
import aoCensored from '@/assets/images/ao-flou.jpg'
import aaCensored from '@/assets/images/attribution-flou.jpg'
import pdfImage from '@/assets/images/ao/pdf-image.jpeg'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import pubImage from '@/assets/images/pub/sarl-fast-informatique.jpg'
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')
const SocialSharing = require('vue-social-sharing')
Vue.use(Viewer)
Vue.use(SocialSharing)
global.v = Vuex
Vue.use(Input)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Dialog)
export default {
  store: window.store,
  created () {
    this.loadingInstance = Loading.service({
      fullscreen: true
    })
    if (this.$route.params.id !== 'undefined') {
      window.axios.get(`/u/appel-offres/${this.$route.params.id}`)
        .then((r) => {
          this.appelOffre = r.data
          let images = this.appelOffre.images.filter(image => image.hasOwnProperty('uri') !== -1)
          images.forEach(data => {
            if (data.mime === 'application/pdf') {
              this.imageSources.push({src: data.uri, mime: data.mime})
            } else {
              this.imageSources.push({ thumb: data.uri, src: data.uri, mime: data.mime })
            }
          })
          this.loadingInstance.close()
        })
        .catch((e) => {
          if (e.response.status === 404) this.$router.replace('/404')
          else if (e.response.status === 422) {
            if (!this.isAuth) {
              this.setLoginRedirectIntent(this.$route.params.id)
              this.$router.push('/login')
            } else {
              this.$router.push('/listappeloffre')
            }
            this.$notify({
              title: 'Abonnement requis',
              message: 'Pour accéder à cet appel d\'offre vous devez disposer d\'un abonnement',
              type: 'error',
              duration: 10 * 1000
            })
          }
        })
    }
  },
  data () {
    return {
      messageCdc: false,
      erreurAcces: '',
      pdfImage: pdfImage,
      procuration: procuration,
      pubImage: pubImage,
      erreurList: [
        {
          text: 'Erreur dans le titre',
          id: 'titre'
        },
        {
          text: 'Image indisponible / non visible',
          id: 'image'
        },
        {
          text: 'Erreur de contenu',
          id: 'contenu'
        },
        {
          text: 'Manque d’information',
          id: 'manque-information'
        },
        {
          text: 'Erreur coordonnées annonceur',
          id: 'coordonnees-annonceur'
        },
        {
          text: 'Autre',
          id: 'autre'
        }
      ],
      loadingInstance: null,
      dialogFormVisible: false,
      dialogFormErreur: false,
      dialogFormEmailVisible: false,
      erreurAo: {
        type: 'titre',
        text: ''
      },
      email: '',
      appelOffre: null,
      imagesAsBase64: [],
      logo: logo,
      source: source,
      formLabelWidth: '120px',
      phone: phone,
      fax: fax,
      map: map,
      imageSources: [],
      showImage: true,
      defaultImage: defaultImage,
      censoredAnnonceur: censoredAnnonceur,
      aoCensored: aoCensored,
      aaCensored: aaCensored
    }
  },
  components: {
    Input,
    Button,
    Loading,
    FormItem,
    LightBox,
    vueHeadful
  },
  props: {
    listeaos: {
      type: Array,
      default: () => { return [] }
    }
  },
  computed: {
    getMetaTitleInfo () {
      return this.appelOffre.titre.length < 60 ? this.appelOffre.titre : `${this.appelOffre.titre.substring(0, 57)}...`
    },
    haveAccessSecteur () {
      if (this.canVieWAo()) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.erreurAcces = 'Niveau d\'accés insufisant'
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.erreurAcces = 'Réservé aux abonnés'
      }
      return true
    },
    getMetaDescriptionInfo () {
      if (this.appelOffre.resume.length > 157) {
        return `${this.appelOffre.resume.substring(0, 157).replace(/<\/?[^>]+>/ig, ' ')}...`
      } else {
        return this.appelOffre.resume.replace(/<\/?[^>]+>/ig, ' ')
      }
    },
    imageSourcesPNG () {
      return this.imageSources.filter((i) => i.mime === 'image/png' || i.mime === 'image/jpeg')
    },
    imageSourcesPDF () {
      return this.imageSources.filter((i) => i.mime === 'application/pdf')
    },
    ...Vuex.mapGetters(['profil', 'isAuth', 'profilLoaded']),
    /**
     * @return {boolean}
     */
    HasPublicationRelier () {
      return this.appelOffre.code.indexOf('...') === -1
    },
    isArabe () {
      const pattern = /[\u0600-\u06FF\u0750-\u077F]/
      return pattern.test(this.appelOffre.titre)
    }
  },
  methods: {
    compareDate () {
      return moment(this.appelOffre.dateEcheance).isAfter(moment(moment().toDate()).format('YYYY-MM-DD'))
    },
    canViewAppeloffre () {
      return !this.appelOffre.is_restricted
    },
    goToAction () {
      if (this.isAuth && this.profil.services.filter((x) => x.name === 'Appel Offre').length > 0) {
        this.$router.push('/monabonnement/')
      } else if (this.isAuth) {
        this.$router.push('/tfabonnement/')
      } else if (!this.isAuth) {
        this.$router.push('/register/')
      }
    },
    async fetchInitialResults () {
      if (this.$route.params.id !== 'undefined') {
        window.axios.get(`/u/appel-offres/${this.$route.params.id}`)
          .then((r) => {
            this.appelOffre = r.data
            let images = this.appelOffre.images.filter(image => image.hasOwnProperty('uri') !== -1)
            images.forEach(data => {
              if (data.mime === 'application/pdf') {
                this.imageSources.push({src: data.uri, mime: data.mime})
              } else {
                this.imageSources.push({ thumb: data.uri, src: data.uri, mime: data.mime })
              }
            })
            this.loadingInstance.close()
          })
          .catch((e) => {
            if (e.response.status === 404) this.$router.replace('/404')
          })
      }
    },
    editAo () {
      const url = process.env.ADMIN_URL + '/appeloffre/' + this.$route.params.id
      window.open(url)
    },
    canVieWAo () {
      if (this.isAuth) {
        return this.profil.services.filter((x) => x.name === 'Appel Offre').length > 0
      }
      return false
    },
    getPrice () {
      return parseInt(this.appelOffre.retrait.prixCDC) + parseInt(this.appelOffre.retrait.wilaya.prixRetrait)
    },
    modalCdc () {
      this.dialogFormVisible = true
      this.messageCdc = false
    },
    getDescription () {
      let tableLot = ''
      if (this.appelOffre.statut === 'attribution-marche') {
        let html = ''
        if (this.appelOffre.lots.length > 0) {
          this.appelOffre.lots.forEach(elem => {
            tableLot += '<tr><td>' + elem.description + '</td><td>' + elem.entreprise + '</td><td>' + new Intl.NumberFormat('fr-FR', {style: 'currency', currency: elem.devise.nom}).format(elem.montant).replace(',00', '') + '</td><td>' + elem.delais + ' jours</td></tr>'
          })
          html = `
        <div class="lots">
          <br>
          <h5>Les lots</h5>
          <table class="table table-bordred table-responsive">
            <thead>
              <tr>
                <th>Description</th>
                <th>Entreprise</th>
                <th>Montant</th>
                <th>Delais</th>
              </tr>
            </thead>
            <tbody>` + tableLot + `
            </tbody>
          </table>
        </div>`
        }
        this.appelOffre.resume = this.appelOffre.resume.replace('%LOTS%', html)
      }
      return this.appelOffre.resume
    },
    printAo () {
      window.axios.get(`/u/appel-offres/pdf/link/${this.$route.params.id}?inline=1`)
        .then((response) => {
          const url = response.data.url
          window.open(url)
        })
    },
    generatePdf () {
      window.axios.get(`/u/appel-offres/pdf/link/${this.$route.params.id}inline=0`)
        .then((response) => {
          const url = response.data.url
          window.open(url)
        })
    },
    sendErreur () {
      const error = {
        id: this.$route.params.id,
        type: this.erreurAo.type,
        description: this.erreurAo.text
      }
      window.axios.post('/u/appel-offres/issues', error)
        .then(() => {
          this.erreurAo.type = 'titre'
          this.erreurAo.text = ''
          const h = this.$createElement
          this.$notify({
            title: 'Signaler une erreur',
            message: h('i', { style: 'color: teal' }, 'Votre rapport a été reçu'),
            type: 'success'
          })
        })
        .catch((e) => {})

      this.dialogFormErreur = false
    },
    sendEmail () {
      // alert('envoi email'
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        window.axios.post(`/u/appel-offres/${this.$route.params.id}/share`, {email: this.email})
          .then(() => {
            this.$notify({
              title: 'Email envoyé',
              message: 'Merci d’avoir utilisé nos services',
              type: 'success'
            })
          })
          .catch((e) => {
            this.$notify({
              title: 'Partage par email',
              message: 'Une erreur est survenue',
              type: 'error'
            })
          })
        this.dialogFormEmailVisible = false
        this.email = ''
      })
    },
    openGallery (index) {
      this.$refs.lightbox.showImage(index)
    },
    searchAnnonceur () {
      this.$router.push('/listappeloffre/?annonceur=' + this.appelOffre.annonceur.id, function () {
        document.location.reload()
      })
    },
    searchPublicationRelier () {
      this.$router.push('/listappeloffre/?annonceur=' + this.appelOffre.annonceur.id + '&' + 'c=' + this.appelOffre.code, function () {
        document.location.reload()
      })
    },
    getFormatDate (data) {
      if (data !== '') {
        return moment(data).format('DD-MM-YYYY')
      } else {
        return ''
      }
    },
    addCdc () {
      window.axios.post('/u/demande-cahier-charge', {
        appelOffre: this.$route.params.id
      })
        .then(() => {
          this.messageCdc = true
          this.$notify({
            title: 'Demande de retrait de cahier de charge',
            message: 'Votre demande a été reçu',
            type: 'success'
          })
          this.appelOffre.retrait.demande_en_cours = true
        })
        .catch((e) => {})
    },
    ...Vuex.mapActions({'getProfilInfoStore': 'getProfilInfo', 'getNotifStore': 'notifStore', 'setLoginRedirectIntent': 'setLoginRedirectIntent'}),
    getStatutAo (value) {
      switch (value) {
        case 'avis-appel-offre':
          return 'Appel d\'offres'
        case 'prorogation-delai':
          return 'Prorogation de délai'
        case 'attribution-marche':
          return 'Attribution de marché'
        case 'annulation':
          return 'Annulation'
        case 'infructuosite':
          return 'Infructuosité'
        case 'vente-enchere':
          return 'Vente aux enchères'
        case 'adjudication':
          return 'Adjudication'
        case 'mise-demeure-information':
          return 'Mise en demeure et résiliation'
        case 'consultation':
          return 'Consultation'
      }
    },
    addRemoveFavoris () {
      if (this.isAuth) {
        if (this.appelOffre.stared.state) {
          window.axios.delete(`/u/appel-offres/stars/${this.appelOffre.stared.id}`)
            .then(() => {
              this.appelOffre.stared.state = false
              this.appelOffre.stared.id = null
              this.$notify({
                title: 'Favoris',
                message: 'Appel d\'offre suprimé des favoris',
                type: 'warning'
              })
            })
        } else {
          window.axios.post('/u/appel-offres/stars', {
            id: this.$route.params.id
          })
            .then((r) => {
              this.appelOffre.stared.state = true
              this.appelOffre.stared.id = r.data.id
              const h = this.$createElement
              this.$notify({
                title: 'Favoris',
                message: h('i', { style: 'color: teal' }, 'Appel d\'offre ajouter au favoris')
                // action axios
              })
            })
        }
      } else {
        this.$notify({
          title: 'Favoris',
          message: 'Vous devez être connecté pour effectuer cette action',
          type: 'error'
        })
      }
    }
  }
}
</script>
<style lang="css">
.card.tf_card .tf_ao_action ul {
    align-items: center;
}
.tf_ao_action ul li .fa-stack {
    font-size: 1.5em !important;
    line-height: 2 !important;
}
.el-dialog__body {
    padding: 1px 20px;
    color: #606266;
    font-size: 14px;
}
.arabe {
    text-align: right;
}
.modal-body {
    padding: 0.5rem !important;
}
hr {
    margin-bottom: 0rem !important;
}
.source_action.multi {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
}
.source_action.multi .source_journal {
    /*flex: 1;*/
}
.tf_card.card-content .source_action.multi .source_journal {
    padding: 0;
    text-align: center;
    margin-right: 50px;
    margin-left: -25px;
}
.source_action.multi .documents_additionels_media {
    height: 100%;
}

.source_action.multi .documents_additionels .dl_content {
    display: inline-flex;

    flex-direction: column;

    justify-content: space-between;
    height: 100%;
}
.source_action.multi .documents_additionels .dl_content > a {
    margin-top: 18px;
    text-align: center;
}
.source_action.multi:after {
    clear: both;
    display: table;
    content: "";
}
.documents_additionels.alone .documents_additionels_media {
    display: flex;
    justify-content: center;
}
.documents_additionels.alone .dl_content {
    display: flex;
    flex-direction: column;
    text-align: center;
}
.source_journal_media img {
    cursor: pointer;
}
.retour-rechercheAO {
    cursor: pointer;
    font-size: 13px;
}
.retour-rechercheAO span {
    color: #c2b59b;
}
.retour-rechercheAO i {
    color: #c2b59b;
}
.retour-rechercheAO:hover span {
    color: #3f342f;
}
.retour-rechercheAO:hover i {
    color: #ec6b23;
}
</style>



// WEBPACK FOOTER //
// src/components/appeloffre/ficheappeloffre.vue